import { ApiProblemError } from '@taler/api-client'

/** The server's own detail message when there is one, so a validation reason survives to the UI. */
export function problemDetail(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.detail : undefined
}

export function isAliasAlreadyExists(error: Error | null): boolean {
  return error instanceof ApiProblemError && error.code === 'journal.merchant_alias_already_exists'
}

export function isAliasCollision(error: Error | null): boolean {
  return error instanceof ApiProblemError && error.code === 'journal.merchant_alias_collides'
}
